export type AnalyticsEnv = {
	TAG_MANAGER_ID?: string
	POSTHOG_API_KEY?: string
	POSTHOG_HOST?: string
	GA_MEASUREMENT_ID?: string
	PRODUCT_ID?: string
	ANALYTICS_ENABLED?: string
	ANALYTICS_EXCLUDED?: string
	MODE?: string
}

export type AnalyticsConfig = {
	enabled: boolean
	tagManagerId?: string
	dataLayer: Record<string, string | undefined>
}

export function getAnalyticsConfig(env: AnalyticsEnv): AnalyticsConfig {
	const enabled = env.ANALYTICS_ENABLED !== 'false'
	return {
		enabled,
		tagManagerId: env.TAG_MANAGER_ID,
		dataLayer: {
			product_id: env.PRODUCT_ID,
			posthog_key: env.POSTHOG_API_KEY,
			posthog_host: env.POSTHOG_HOST,
			ga_id: env.GA_MEASUREMENT_ID,
			environment: env.MODE,
		},
	}
}
